import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { useCountDown, useI18N } from "@sundae/react-hooks";
import { Text, toolkitCx } from "@sundae/ui-toolkit";
import { ITextProps } from "@sundae/ui-toolkit/dist/types/components/atoms/Text/Text";
import cx from "classnames";
import { FC, useCallback } from "react";
import { createPortal } from "react-dom";

import { EARNINGS_COUNTDOWN_ID } from "../../../constants/page.constants";
import { displayTimeValue, getNext2amUTCDate } from "../../../utils/time.utils";

interface IEarningsCountdownProps extends Pick<ITextProps, "size" | "variant"> {}

export const CountdownComponent: FC<IEarningsCountdownProps> = ({ size = "base", variant }) => {
  const { t } = useI18N();
  const targetDate = getNext2amUTCDate();
  const [, { days, hours, minutes, seconds }] = useCountDown({
    targetDate,
  });

  const countdownNode = document.getElementById(EARNINGS_COUNTDOWN_ID);

  const renderContent = useCallback(() => {
    if (!days && !hours && !minutes && !seconds) {
      return (
        <Text className="text-right" tag="div" size={size} variant="warning">
          <ExclamationTriangleIcon
            className={cx("inline-flex h-4 w-4", toolkitCx.layout.text.warning)}
          />{" "}
          {t("detail.countdown.ended")}
        </Text>
      );
    }

    return (
      <Text tag="span" size={size} variant={variant}>
        {[hours, minutes, seconds].map(displayTimeValue).join(":")}
      </Text>
    );
  }, [days, hours, minutes, seconds]);

  return countdownNode && createPortal(renderContent(), countdownNode);
};

export const CountdownNode: FC = () => <div id={EARNINGS_COUNTDOWN_ID} />;

const Countdown: FC<IEarningsCountdownProps> = (props) => {
  return (
    <>
      <CountdownComponent {...props} />
      <CountdownNode />
    </>
  );
};

export default Countdown;
